"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const plc_1 = require("../../../@inax/plc");
const logger_1 = require("../../../@inax/logger");
class PlcItem {
    constructor(name, value) {
        this.name = name;
        this.value = value;
    }
}
exports.PlcItem = PlcItem;
let PlcViewerComponent = class PlcViewerComponent {
    constructor(_inaxPlc, _logger) {
        this._inaxPlc = _inaxPlc;
        this._logger = _logger;
        this.state = "not connected";
        this.area = "DB1112";
        this.address = "W0";
        this.groupName = "XXX";
        this.plcId = "";
        this.mapping = "DB_BST1_Organisation";
        this.varname = "This";
        this.selectedSymbol = "?";
        this.reads = [];
        this.subscribed = [];
    }
    ngOnInit() {
        // this._webPacService.subscribeConnectionChanged().subscribe((state) => {
        //     this.state = state.Connected ? "connected" : "not connected";
        // });
    }
    subscribe(item) {
        this.subscribed.push(item);
        item.isSubscribed = true;
        this.updateWatcher();
    }
    unsubscribe(item) {
        let idx = this.subscribed.indexOf(item);
        if (idx != -1) {
            this.subscribed.splice(idx, 1);
            item.isSubscribed = false;
            this.updateWatcher();
        }
    }
    updateWatcher() {
        if (this._proxy != null)
            this._proxy.dispose();
        this._proxy = this._inaxPlc.createEventProxy(this.groupName, this.plcId, this.mapping, this.subscribed.map(x => x.name));
        this._proxy.ChangeEvent.subscribe((dce) => this.dataUpdated(dce), (error) => {
            this.subscribed.forEach(item => item.isSubscribed = false);
            console.warn("Attempt to join channel failed!", error);
        });
    }
    onRead() {
        try {
            this.selectedSymbol = "?";
            this._inaxPlc.read(this.plcId, this.mapping, [this.varname]).subscribe((data) => {
                try {
                    if (data != null && data.This != null) {
                        this.selectedSymbol = this.mapping;
                        this.reads = new Array();
                        this._logger.logInfo(`successfully red data from ${this.mapping}`, true);
                        this.resolveObject(this.reads, data.This, null, false);
                    }
                    else {
                        console.warn("no data red!");
                    }
                }
                catch (error) {
                    console.warn("no data red!");
                }
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    onWrite(item) {
        try {
            this._inaxPlc.write(this.plcId, this.mapping, item.name, item.value).subscribe((data) => {
                console.warn(data);
            });
        }
        catch (error) {
            console.error(error);
        }
    }
    dataUpdated(ev) {
        this.subscribed.forEach(updated => {
            try {
                if (updated != null) {
                    console.warn(`onEvent - ${ev.Mapping}.${updated.name}`);
                    eval("updated.value = ev.Data." + updated.name);
                }
            }
            catch (error) {
                console.warn(`Error updateing data! ${error}`);
            }
        });
    }
    resolveObject(result, object, prefix, onlyVarNames) {
        let isArray = Array.isArray(object);
        //no prefix -> set it to null to handle only one value in the loop
        if (prefix == "")
            prefix = null;
        //onlyVarNames is true -> if this object isn't an array, clear prefix
        if (prefix != null && (!isArray && onlyVarNames))
            prefix = null;
        //loop through the object
        for (var property in object) {
            if (object.hasOwnProperty(property)) {
                //get name and data
                var value = object[property];
                var name = prefix != null ?
                    isArray ? prefix + "[" + (Number(property) + 1) + "]" : prefix + "." + property :
                    isArray ? "[" + (Number(property) + 1) + "]" : property;
                if (value === Object(value)) {
                    //property is an object, so step up to handle these properties
                    this.resolveObject(result, value, name, onlyVarNames);
                }
                else {
                    //normal property, so save it to resultSet
                    result.push(new PlcItem(name, String(value)));
                }
            }
        }
    }
};
PlcViewerComponent = __decorate([
    core_1.Component({
        selector: 'plc-viewer',
        templateUrl: 'app/components/plcviewer/plcviewer.component.html',
        styleUrls: ['app/components/plcviewer/plcviewer.component.css']
    }),
    __metadata("design:paramtypes", [plc_1.InaxPlcService,
        logger_1.InaxLoggerService])
], PlcViewerComponent);
exports.PlcViewerComponent = PlcViewerComponent;
